export const host =  JSON.parse(process.env.VUE_APP_USE_HOST.toLowerCase()) ? location.host : location.hostname;
export const siteUrl = process.env.VUE_APP_SITE_HOST_NAME_LOCAL;